import { render, staticRenderFns } from "./ForecastPKFO-3.vue?vue&type=template&id=5da35681&"
import script from "./ForecastPKFO-3.vue?vue&type=script&lang=js&"
export * from "./ForecastPKFO-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports